import React, { useEffect, useState } from "react";
import Default from "../../components/defaults/Default";
import { NavLink, useParams } from "react-router-dom";
import PostRequest from "../../servies/PostRequest";
import Moment from "react-moment";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoCheckmarkDoneOutline } from "react-icons/io5";

var originalCopyOfData = [];

const Responses = () => {
  const params = useParams();
  const [formsResponseData, setFormResponseData] = useState({});
  const [mailsSent, setMailsSend] = useState({});
  const [loading, setLoading] = useState(true);

  const [count, setCount] = useState({
    sent: "",
    pending: "",
  });

  const responseId = params.id || "t0DoMPhK";

  const loadFormResponse = async () => {
    try {
      const data = {
        formId: responseId,
      };

      const response = await PostRequest("/form/response", data);

      originalCopyOfData = response?.formResponse;

      setFormResponseData(response?.formResponse);
      setMailsSend(response?.mailsStatus);

      setCount({
        sent: Object.keys(response?.mailsStatus).length,
        pending:
          response?.formResponse?.items.length -
          Object.keys(response?.mailsStatus).length,
      });
    } catch (error) {}
    setLoading(false);
  };

  const handleFilter = (event) => {
    switch (event.target.value) {
      case "pending":
        const pending = [...originalCopyOfData?.items].filter(
          (data) => !mailsSent[_getFieldData("YhEx9aMSUXej", data)],
        );
        setFormResponseData({ ...formsResponseData, items: pending });
        break;

      case "sent":
        const sent = [...originalCopyOfData?.items].filter(
          (data) => mailsSent[_getFieldData("YhEx9aMSUXej", data)],
        );
        setFormResponseData({ ...formsResponseData, items: sent });
        break;

      default:
        setFormResponseData({ ...originalCopyOfData });
    }
  };

  const _getFieldData = (id, data) => {
    const value = data.answers.find((answer) => answer.field.id == id);
    if (!value) return "-";

    return value[value.type];
  };

  useEffect(() => {
    loadFormResponse();
  }, []);

  return (
    <Default>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-title">
            <div className="row">
              <div className="col-6">
                <h3>SEOL Map Assessment</h3>
              </div>
              <div className="col-6">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a className="home-item" href="#">
                      <i data-feather="home" />
                    </a>
                  </li>
                  <li className="breadcrumb-item">Home</li>
                  <li className="breadcrumb-item">Forms</li>
                  <li className="breadcrumb-item active">Responses</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* Container-fluid starts*/}
        <div className="container-fluid ecommerce-page">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="card">
                <div className="card-header pb-0">
                  <div className="d-flex align-items-center">
                    <h3>Forms Responses</h3>
                    <span className="badge badge-success ms-2">
                      {count.sent} Mails Sent
                    </span>
                    <span className="badge badge-info">
                      {count.pending} Mails Pending
                    </span>
                  </div>
                  <div className="card-header-right">
                    <select onChange={handleFilter} className="form-control">
                      <option value=""> All </option>
                      <option value="pending"> Mail Pending </option>
                      <option value="sent"> Mail Sent </option>
                    </select>
                  </div>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="text-center p-5">
                      <AiOutlineLoading3Quarters
                        size={50}
                        className="fa-spin fa-spinner"
                      />
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordernone">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Email</th>
                            {/* <th>Self Mastery</th>
                            <th>Relationships</th>
                            <th>Fitness</th>
                            <th>Career / Mission</th>
                            <th>Economics</th>
                            <th>Mentors</th>
                            <th>Lifestyle</th>
                            <th>Service</th> */}
                            <th>Response Status</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formsResponseData?.items?.map(
                            (responseData, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <Moment
                                      format="lll"
                                      date={responseData.submitted_at}
                                    />
                                  </td>
                                  <NavLink
                                    to={`/forms/${responseId}/${_getFieldData(
                                      "YhEx9aMSUXej",
                                      responseData,
                                    )}`}
                                    state={responseData}
                                  >
                                    <td className="formResponseView">
                                      {_getFieldData(
                                        "0YMrCEqzAsQc",
                                        responseData,
                                      )}
                                    </td>
                                  </NavLink>
                                  <td>
                                    {_getFieldData(
                                      "YhEx9aMSUXej",
                                      responseData,
                                    )}
                                  </td>
                                  {/* ...existing code... */}
                                  <td>
                                    {responseData.response_type ==
                                    "completed" ? (
                                      <span className="text text-success">
                                        Completed
                                      </span>
                                    ) : (
                                      <span className="text text-info">
                                        Not Completed
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {mailsSent[
                                      _getFieldData(
                                        "YhEx9aMSUXej",
                                        responseData,
                                      )
                                    ] ? (
                                      <span className="badge badge-success">
                                        <IoCheckmarkDoneOutline /> Mail Sent
                                      </span>
                                    ) : (
                                      <span className="badge badge-info">
                                        Pending
                                      </span>
                                    )}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ color: "#534686" }}
                                  >
                                    <div>
                                      <NavLink
                                        style={{ fontSize: "0.75em" }}
                                        className={"formResponseView font"}
                                        to={`/forms/${responseId}/${_getFieldData(
                                          "YhEx9aMSUXej",
                                          responseData,
                                        )}`}
                                        state={responseData}
                                      >
                                        View
                                      </NavLink>
                                    </div>
                                  </td>
                                </tr>
                              );
                            },
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="code-box-copy">
                    <button
                      className="code-box-copy__btn btn-clipboard"
                      data-clipboard-target="#employee-status"
                      title
                      data-bs-original-title="Copy"
                      aria-label="Copy"
                    >
                      <i className="icofont icofont-copy-alt" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Container-fluid Ends*/}
      </div>
    </Default>
  );
};

export default Responses;
